import AuthApi from '@/api/zfb/auth'
import { Service_Tb1688FxAppKey } from '@/service/tb_1688_service'

// 获取该店铺授权的应用
async function GetAuthAppList(page,size,relationId) {
  return await AuthApi.GetAuthAppList(page, size, relationId, Service_Tb1688FxAppKey)
}

// 获取添加授权店铺的链接
async function GetAddAuthAppLink(relationId) {
  return await AuthApi.GetAddAuthAppLink(Service_Tb1688FxAppKey, relationId)
}

// 删除某个1688授权账号
function DeleteAliAuth(relationId) {
  return AuthApi.DeleteAliAuth(relationId)
}

export default { GetAuthAppList, GetAddAuthAppLink, DeleteAliAuth }
